import SharedDialogActions, {
  Justify,
} from '@shared/components/dialog/DialogActions';

const DialogActions = ({ children }) => (
  <SharedDialogActions justify={ Justify.Right }>{children}</SharedDialogActions>
);

export default DialogActions;
